import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const AddEditIntegrationModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "AddEditIntegrationModalContainer" */
      './AddEditIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
